export const entityLabelFunc = {
    lead: ({TITLE}) => TITLE,
    contact: ({LAST_NAME, NAME, SECOND_NAME}) => [LAST_NAME, NAME, SECOND_NAME].filter(val => typeof val === 'string' && val.length > 0).join(` `),
    company: ({NAME}) => NAME
};